module.exports = __webpack_public_path__ + "img/view.bb9c4ebf.svg";